//utils:
const Event = require("util/Event");
const Misc = require("util/Misc");
const Validator = require("util/Validator");
const Formatter = require("util/Formatter");

let InputHelper = {
    //MAYBE WE SHOULD ONLY DO THIS IF A SECTION WITH INPUT IS OPENED?
    initialize : function() {
        InputHelper.initialized = true;
        Event.enter(".input-wrapper input, .textarea-wrapper textarea", InputHelper.onEnter);
        Event.listen(".input-wrapper .input-file", "change", InputHelper.onFileInputChange);
        Event.listen(".input-wrapper input", "focusin", InputHelper.onInputFocusIn);
        Event.listen(".input-wrapper input", "focusout", InputHelper.onInputFocusOut);
        Event.listen(".input-wrapper input", "customfocusout", InputHelper.onInputFocusOut);
        Event.listen(".input-wrapper input", "keyup", InputHelper.onInputChange);
        Event.listen(".input-wrapper input", "validate", InputHelper.onValidate);
        Event.listen(".input-wrapper input", "reset", InputHelper.onReset);
        Event.listen(".textarea-wrapper textarea", "focusin", InputHelper.onInputFocusIn);
        Event.listen(".textarea-wrapper textarea", "focusout", InputHelper.onInputFocusOut);
        Event.listen(".textarea-wrapper textarea", "keyup", InputHelper.onInputChange);
        Event.listen(".textarea-wrapper textarea", "validate", InputHelper.onTAValidate);
        Event.listen(".textarea-wrapper textarea", "reset", InputHelper.onReset);
        Event.listen("button.ddl, label.btn-look-alike.ddl li", "mark-default", InputHelper.onDLLDefaultRequest);
        Event.listen("button.ddl, label.btn-look-alike.ddl", "reset", InputHelper.onDDLResetRequest);
        Event.tap("button.ddl, label.btn-look-alike.ddl:not(.multi)", InputHelper.onDDLTap);
        Event.tap("button.ddl, label.btn-look-alike.ddl.multi", InputHelper.onMultiDDLTap);
        Event.tap("nav.multi-select button.tab", InputHelper.onMultiSelectBtnTap);
        Event.tap("nav.tab-comp:not(.multi-select) button.tab", InputHelper.onNavTabBtnTap);
        Event.tap(".single-select .tab:not(.active)", InputHelper.onSingleSelectTap);
        Event.tap("form .desc-icon", InputHelper.onDescTap);
        Event.tap(".input-wrapper.img-input-wrapper .span-label.with-value", InputHelper.onFileCancel);
        Event.listen(".input-wrapper .ddl", "validate", InputHelper.onDDLValidate);
    },

    onEnter(e){
        $(e.currentTarget).blur();
    },

    onDescTap(e){
        let $icon = $(e.currentTarget);
        let $parent = $icon.parent();
        $parent.toggleClass("with-desc");
    },

    onNavTabBtnTap : function(e){
        let $btn = $(e.currentTarget);
        let $parent = $btn.parent();
        let $activeBtn = $("button.tab.active", $parent);
        if($activeBtn.attr("id") === $btn.attr("id"))
            return;
        $activeBtn.removeClass("active");
        $btn.addClass("active");
        $btn.trigger("nav_tab_changed");
    },


    onMultiSelectBtnTap : function(e){
        let $btn = $(e.currentTarget);
        let $parent = $btn.parent();
        $btn.toggleClass("active");
        let $activeBtns = $("button.tab.active", $parent);
        if($activeBtns.length === 0){
            $btn.toggleClass("active");
        }
        $btn.trigger("multi_select_tab_changed");
    },

    onSingleSelectTap : function(e){
        let $tab = $(e.currentTarget);
        let $parent = $tab.parent();
        $(".tab.active", $parent).removeClass("active");
        $tab.addClass("active");
        $tab.trigger("singleSelectChange");
    },

    onDDLResetRequest(e){
        let $btn = $(e.currentTarget);
        let $parent = $btn.parent();
        let $errLb = $(".error-label", $parent);
        $errLb.css("display","none");
        $parent.removeClass("focused with-value valid invalid");
        $("label",$btn).removeClass("with-value").text("Select...");
        $("li", $btn).removeClass("active");
        $btn.removeAttr("data-old-value");
    },

    onDLLDefaultRequest(e){
        let $li = $(e.currentTarget);
        let $btn = $li.parents(".ddl");
        if($btn.length === 0){
            if($li.hasClass("ddl")){
                $btn = $li;
                $li = $("li.active", $btn);
            }
        }
        $("label",$btn).addClass("with-value").text($li.text());
        $btn.attr("data-selected-value", $li.attr("data-value"));
        $btn.attr("data-old-value", $li.attr("data-value"));
        $btn.parents(".input-wrapper").addClass("with-value");
        $("li", $btn).removeClass("active");
        $li.addClass("active");
        $btn.trigger({type : "ddl_changed", selectedValue : $li.attr("data-value")});
    },

    onDDLTap : function(e){
        let $btn = $(e.currentTarget);
        if($btn.attr("busy"))
            return;
        if($btn.hasClass("off"))
            return;
        $btn.attr("busy", true);

        let $parent = $btn.parent();
        let $target = $(e.target);
        let isOpen = $btn.hasClass("open");

        const bodyTapFn = function(bodyEvt){
            Event.bodyTap(bodyTapFn, true);
            if($btn.attr("busy"))
                return;
            Event.bodyTap(bodyTapFn, true);
            $btn.removeClass("open");
            triggerEvent();
            if($parent.hasClass("invalid"))
                InputHelper.onDDLValidate(e);
            if($btn.attr("data-static")){
                $btn.removeAttr("data-selected-value");
                $("li", $btn).removeClass("active");
            }
        };

        const triggerEvent = function(){
            let newVal = $btn.attr("data-selected-value");
            let oldVal = $btn.attr("data-old-value");
            if(newVal != oldVal){
                $btn.trigger({type : "ddl_changed", selectedValue : newVal});
                if(!$btn.attr("data-static"))
                    $btn.attr("data-old-value", newVal);
            }
        };

        if($parent.hasClass("with-desc"))
            $parent.removeClass("with-desc");

        if(isOpen){
            Event.bodyTap(bodyTapFn, true);
            let $liParent = $target.parents(".ddl-item");
            if($liParent.length > 0)
                $target = $liParent;
            if($target.is( "li" )) {
                let val = $target.attr("data-value");
                $("li", $btn).removeClass("active");
                $btn.attr("data-selected-value", val);
                if(!$btn.attr("data-static")){
                    $("label",$btn).addClass("with-value").text($target.text());
                    $target.addClass("active");
                    $parent.addClass("with-value");
                }
                triggerEvent();
                if($parent.hasClass("invalid"))
                    InputHelper.onDDLValidate(e);
            }
            $btn.removeClass("open");
        }
        else{
            $btn.addClass("open");
            Event.bodyTap(bodyTapFn);
        }
        Misc.callLater(function(){
            $btn.removeAttr("busy");
        }, 250);
    },

    onMultiDDLTap : function(e){
        let $btn = $(e.currentTarget);
        if($btn.attr("busy"))
            return;
        $btn.attr("busy", true);

        let $parent = $btn.parent();
        let $target = $(e.target);
        let isOpen = $btn.hasClass("open");

        const bodyTapFn = function(bodyEvt){
            if($btn.attr("busy"))
                return;
            Event.bodyTap(bodyTapFn, true);
            $btn.removeClass("open");
        };

        if($parent.hasClass("with-desc"))
            $parent.removeClass("with-desc");

        if(isOpen){
            if($target.is( "li" )) {
                let $parent = $target.parent();
                let $activeLi = $("li.active", $parent);
                if($activeLi.length > 1 || !$target.hasClass("active")){
                    $target.toggleClass("active");
                    let val = $target.attr("data-value");
                    $btn.trigger({type : "ddl_changed", selectedValue : val});
                }
            }
            else{//close
                Event.bodyTap(bodyTapFn, true);
                $btn.removeClass("open");
            }
        }
        else{
            $btn.addClass("open");
            Event.bodyTap(bodyTapFn);
        }
        Misc.callLater(function(){
            $btn.removeAttr("busy");
        }, 250);
    },

    onReset : function(e){
        let $input = $(e.currentTarget);
        let $parent = $input.parent();
        let $errLb = $(".error-label", $parent);
        $errLb.css("display","none");
        $parent.removeClass("focused with-value valid invalid");
    },

    onInputFocusIn : function(e){
        let $input = $(e.currentTarget);
        if($input.hasClass("not-this-one"))
            return;
        let $parent = $input.parent();
        if(!$parent.hasClass(".input-wrapper") || !$parent.hasClass(".textarea-wrapper")){
            $parent = $input.parents(".input-wrapper");
        }
        $parent.addClass("focused");
    },

    onValidate : function(e) {
        InputHelper.invokeValidation(e, true);
    },

    onDDLValidate : function(e) {
        InputHelper.invokeValidation(e, true);
    },

    onTAValidate : function(e) {
        InputHelper.invokeValidation(e, true);
    },

    onInputFocusOut : function(e){
        let $input = $(e.currentTarget);
        let $parent = $input.parent();
        let formatField = $parent.attr("data-format");
        let allowNegative = $input.attr("data-allow") == "negative";
        if(!$parent.hasClass(".input-wrapper") || !$parent.hasClass(".textarea-wrapper")){
            $parent = $input.parents(".focused");
        }
        $parent.removeClass("focused");
        if($input.val().length > 0){
            $parent.addClass("with-value");
            if(formatField){
                $input.val(Formatter[formatField]($input.val(), allowNegative));
            }
        }
        else{
            $parent.removeClass("with-value");
        }
    },

    onInputChange : function(e){
        var code = e.which;
        if(code == 13) // is enter no need to execute bellow.
            return;
        InputHelper.invokeValidation(e);
    },

    onFileCancel(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        let $parent = $(e.currentTarget).parents(".input-wrapper");
        let $input = $("input", $parent);
        let $label = $('label.file-label', $parent);

        $(".preview-img", $label).attr("src", "");
        $(".span-label", $label).text("Choose A File").removeClass("with-value");
        $input.val("");
    },

    onFileInputChange : function(e){
        let $input = $(e.currentTarget);
        let $label = $input.siblings('label.file-label');
        var filename = $input.val().split('\\').pop();
        if(!filename || filename.length < 1){
            filename = "Choose A File";
            InputHelper.invokeValidation(e, true);
            $(".preview-img", $label).attr("src", "");
            $(".span-label", $label).removeClass("with-value");
        }
        else{
            $(".span-label", $label).addClass("with-value");
        }
        $(".span-label", $label).text(filename);
    },

    invokeValidation : function(e, force){
        let $input = $(e.currentTarget);
        let $parent = $input.parent();
        let validatorName = $parent.attr("data-input-validator");
        let optionalValidatorName = $parent.attr("data-input-validator2");
        let $errLb = $(".error-label", $parent);
        let isOptional = false;
        if(optionalValidatorName){
            force = false;
            isOptional = true;
            validatorName = optionalValidatorName;
        }
        let val = $input.val();
        if($input.hasClass("ddl"))
            val = $input.attr("data-selected-value");
        if(validatorName){
            if(val && val.length > 0 || force){
                let isValidNow = $parent.hasClass("valid");
                let isValid = Validator[validatorName](val, $input);
                if(isValid){
                    $parent.addClass("valid").removeClass("invalid");
                    $errLb.css("display","none");
                }
                else if(isValidNow || force || isOptional){
                    $parent.addClass("invalid").removeClass("valid");
                    $errLb.css("display","inline-block");
                    Misc.scrollToElm($parent, 170);
                }
            }
            else{
                $parent.removeClass("invalid valid");
                $errLb.css("display","none");
            }
        }
    }
};

module.exports = InputHelper;



// WEBPACK FOOTER //
// ./src/control/core/InputHelper.js